"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _solarReact = require("@solar/solar-react");

var _styles = require("@material-ui/core/styles");

var _FileUpload = _interopRequireDefault(require("./FileUpload"));

require("cropperjs/dist/cropper.css");

var _excluded = ["src", "cropData", "onAdd", "onReplace", "onCrop", "onRemove", "getAWSSignedUrl", "labels"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {},
    progres: {}
  };
});

var _default = function _default(_ref) {
  var src = _ref.src,
      cropData = _ref.cropData,
      onAdd = _ref.onAdd,
      onReplace = _ref.onReplace,
      onCrop = _ref.onCrop,
      _onRemove = _ref.onRemove,
      getAWSSignedUrl = _ref.getAWSSignedUrl,
      labels = _ref.labels,
      other = _objectWithoutProperties(_ref, _excluded);

  var t = _objectSpread(_objectSpread({}, labels), {}, {
    actions: _objectSpread(_objectSpread({}, labels.actions), {}, {
      cancel: labels.photoUpload.cancel
    })
  });

  var classes = useStyles();
  var fileuploadRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(src ? 'crop' : 'default'),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      _src = _useState4[0],
      setSrc = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = _slicedToArray(_useState5, 2),
      _cropData = _useState6[0],
      setCropData = _useState6[1];

  var _useState7 = (0, _react.useState)(),
      _useState8 = _slicedToArray(_useState7, 2),
      _fileData = _useState8[0],
      setFileData = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      uploading = _useState10[0],
      setUploading = _useState10[1];

  var _useState11 = (0, _react.useState)(0),
      _useState12 = _slicedToArray(_useState11, 2),
      progress = _useState12[0],
      setProgress = _useState12[1];

  return /*#__PURE__*/_react["default"].createElement(_solarReact.UploadImageDialog, _extends({
    state: state,
    onRemove: function onRemove() {
      _onRemove();
    },
    onImageReset: function onImageReset() {
      setSrc(null);
      setState('default');
      setCropData(null);
    },
    onClear: function onClear() {
      setSrc(false);
    },
    onImageChange: setSrc,
    changeState: setState,
    onStartUpload: function onStartUpload() {
      return fileuploadRef.current.startUpload();
    },
    t: t,
    src: _src === false ? null : _src || src,
    cropData: _cropData || cropData,
    onCropChange: setCropData,
    uploading: uploading,
    progress: progress,
    uploader: /*#__PURE__*/_react["default"].createElement(_FileUpload["default"], {
      ref: fileuploadRef,
      onlyImages: true,
      getAWSSignedUrl: getAWSSignedUrl,
      onComplete: function onComplete(data) {
        setFileData(data);
        setSrc(data.url);
      },
      onChange: function onChange(_ref2) {
        var uploading = _ref2.uploading,
            progress = _ref2.progress;
        setUploading(uploading);
        setProgress(progress);
      }
    }),
    onComplete: function onComplete() {
      // if no cover beforehand, add one
      if (!src) {
        // console.log('onAdd');
        onAdd(_objectSpread(_objectSpread({}, _fileData), {}, {
          cropData: _cropData
        }));
      } else if (_src && src !== _src) {
        // console.log('onReplace');
        // if image was replaced, replace imageRef
        onReplace(_objectSpread(_objectSpread({}, _fileData), {}, {
          cropData: _cropData
        }));
      } else if (_cropData) {
        // console.log('onCrop');
        // if only recropped, update cropInfo
        onCrop(_cropData);
      } else if (cover.original) {
        // console.log('onRemove');
        // no cropData and no original?
        // image must have been removed
        _onRemove();
      }
    }
  }, other));
};

exports["default"] = _default;